import axios from "axios";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

var instance = axios.create({
  timeout: 1000 * 30
});
//暂时放开
axios.defaults.headers.agentId = "1";

// 题库 start =================

export const created = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/createQuestions`, data)
}

export const edited = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/updateQuestion/${data}`)
}

export const deleted = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/deleteQuestion/batch`,data)
}

// 题库 end ===================



// WEBPACK FOOTER //
// ./src/api/es-search.js